import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';
import { stringify } from '@client/common/utils/queryParams';
import { StatisticsExportParams, StatisticsQueryParams } from 'b2b-common/core/account/api/Statistics.types';

export class Statistics {
  public static fetchOverall(startDate: string, endDate: string): RequestConfigType {
    const searchParams = {
      startDate,
      endDate,
    };
    return RequestConfig.get(`/account/statistics/overall?${stringify(searchParams)}`);
  }

  public static fetchManufacturers(params: StatisticsQueryParams): RequestConfigType {
    return RequestConfig.get(`/account/statistics/manufacturers?${stringify(params)}`);
  }

  public static fetchProductGroups(params: StatisticsQueryParams): RequestConfigType {
    return RequestConfig.get(`/account/statistics/product-groups?${stringify(params)}`);
  }

  public static exportStatistics(params: StatisticsExportParams): RequestConfigType {
    return RequestConfig.get(`/account/statistics/export?${stringify(params)}`, {
      responseType: 'arraybuffer',
    });
  }
}

